import React, { useState, useEffect, memo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { VerifyAccount } from '../../api/endpoints'
import AuthWrapper from './components/authWrapper';
import { CRRender } from '../../components/crRender';

const VerifyAcc = () => {
    const [showLogin, setshowLogin] = useState(false);
    const [searchParams] = useSearchParams();
    const { t, i18n } = useTranslation();

    useEffect(() => {
        let code = searchParams.get("code");

        VerifyAccount(code).then(result => {
            setshowLogin(true);
        })
    }, [searchParams])

    return (
        <AuthWrapper>
            <div className='message' >
                <img className='checkimg' src='images/check.png' width="20" height="20" alt="logo" />
                <div>{t("Your account is verified successfully")}</div>
            </div>
            <CRRender isRender={showLogin} >
                <button className="btn btn-light" >
                    <span role="status" aria-hidden="true"></span>
                    <Link to="/login" >{t("login")}</Link>
                </button>
            </CRRender>
            <div className="clearfix"></div>

            <div className="separator"></div>
        </AuthWrapper>

    );
}

export default memo(VerifyAcc);

